(() => {
  const initFloatingActions = () => {
    const actions = document.querySelector('[data-floating-actions]');
    if (!actions || actions.dataset.initialized === 'true') return;

    actions.dataset.initialized = 'true';

    const topButton = actions.querySelector('[data-floating-actions-top]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let previousScrollY = Math.max(window.scrollY, 0);
    let animationFrameId = 0;

    const setHidden = (hidden) => {
      if (actions.classList.contains('is-hidden') === hidden) return;

      actions.classList.toggle('is-hidden', hidden);
      actions.toggleAttribute('inert', hidden);
      actions.setAttribute('aria-hidden', String(hidden));
    };

    const updateVisibility = () => {
      animationFrameId = 0;

      const currentScrollY = Math.max(window.scrollY, 0);
      const scrollDistance = currentScrollY - previousScrollY;

      // Keep the controls completely out of the first viewport so they do not
      // cover introductory content, especially on narrow mobile screens.
      if (currentScrollY <= window.innerHeight) {
        setHidden(true);
        previousScrollY = currentScrollY;
        return;
      }

      if (Math.abs(scrollDistance) < 8) return;

      setHidden(scrollDistance > 0);
      previousScrollY = currentScrollY;
    };

    window.addEventListener('scroll', () => {
      if (animationFrameId) return;
      animationFrameId = requestAnimationFrame(updateVisibility);
    }, { passive: true });

    topButton?.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: reduceMotion.matches ? 'auto' : 'smooth',
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFloatingActions, { once: true });
  } else {
    initFloatingActions();
  }
})();
